<div id="back-top">
  <a href="#top" (click)="goTop($event)" title="Topo"><img src="images/topo.svg" alt="Topo" /></a>
</div>
